
import Vue from 'vue'

Vue.component('delta-calculator', require('./index.vue').default);
Vue.component('delta-range-slider', require('./components/delta-range-slider.vue').default);

document.querySelectorAll('.vue-inst').forEach(el => {
    new Vue({el: el, data: {}})
});
